<template>
  <!-- <app-client-layout title="解説">
    <template #header>
      <h2 class="text-xl font-semibold leading-tight text-gray-800">
        解説
      </h2>
    </template> -->
  <button
    :class="props.type === '1' ?
      'bg-green-300 ml-10 mt-4 border-solid border-1 border-gray-200 lg:hover:bg-green-300 active:bg-green-300 duration-300 text-black py-2.5 px-10 sp:px-7 sp:text-sm rounded-lg':
      'bg-white ml-10 mt-4 border-solid border-2 border-gray-200 lg:hover:bg-green-300 active:bg-green-300 duration-300 text-black py-2.5 px-10 sp:px-7 sp:text-sm rounded-lg'"
    @click="onClickedType(1)">
    必須
  </button>
  <button
    :class="props.type === '2' ?
      'bg-green-300 ml-4 mt-4 border-solid border-1 border-gray-200 lg:hover:bg-green-300 active:bg-green-300 duration-300 text-black py-2.5 px-10 sp:px-7 sp:text-sm rounded-lg':
      'bg-white ml-4 mt-4 border-solid border-2 border-gray-200 lg:hover:bg-green-300 active:bg-green-300 duration-300 text-black py-2.5 px-10 sp:px-7 sp:text-sm rounded-lg'"
    @click="onClickedType(2)">
    一般
  </button>
  <button
    :class="props.type === '3' ?
      'bg-green-300 ml-4 mt-4 border-solid border-1 border-gray-200 lg:hover:bg-green-300 active:bg-green-300 duration-300 text-black py-2.5 px-10 sp:px-7 sp:text-sm rounded-lg':
      'bg-white ml-4 mt-4 border-solid border-2 border-gray-200 lg:hover:bg-green-300 active:bg-green-300 duration-300 text-black py-2.5 px-10 sp:px-7 sp:text-sm rounded-lg'"
    @click="onClickedType(3)">
    実地
  </button>
  <button
    class="bg-white ml-4 mt-4 border-solid border-2 border-gray-200 lg:hover:bg-green-300 active:bg-green-300 duration-300 text-black py-2.5 px-10 sp:px-7 sp:text-sm rounded-lg"
    @click="onClickedAnswerListButton">
    解答一覧
  </button>
  <div class="md:flex md:justify-center">
    <template v-if="questionListMenu">
      <result-list
        :all-questions="allQuestions"
        :on-resize="onResize"
        :question-list-menu="questionListMenu"
        :examination="examination"
        :type="type"
        :question="question"
        :questions="questions"
        :index="index"
        :is-clicked-question-list="isClickedQuestionList"
        :all-answer-question-answers="allAnswerQuestionAnswers"
        @confirmation="onOpenConfirmationModal"
        @on-clicked-question-list-menu="onClickedQuestionListMenu" />
    </template>
    <div class="md:py-4 md:w-4/6">
      <commentary
        :all-questions="allQuestions"
        :on-resize="onResize"
        :question-list-menu="questionListMenu"
        :examination="examination"
        :type="type"
        :question="question"
        :questions="questions"
        :index="index"
        :current-question-answer-type="currentQuestionAnswerType"
        :choices-order="choicesOrder"
        @confirmation="onOpenConfirmationModal"
        @on-clicked-question-list-menu="onClickedQuestionListMenu" />
    </div>
  </div>
  <!-- </app-client-layout> -->
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import Swal from 'sweetalert2'
import {
  computed, reactive, ref, onMounted,
} from 'vue'
import AppClientLayout from '@/Layouts/AppClientLayout'
import ResultList from './ResultList'
import Commentary from './Commentary'

const props = defineProps({
  allQuestions: {
    type: Array,
    default: () => [],
  },
  question: {
    type: Object,
    default: () => {},
  },
  questions: {
    type: Array,
    default: () => [],
  },
  examination: {
    type: Object,
    default: () => {},
  },
  type: {
    type: String,
    default: null,
  },
  index: {
    type: Number,
    default: 0,
  },
  purchases: {
    type: Array,
    default: () => ([]),
  },
  currentQuestionAnswerType: {
    type: Number,
    default: null,
  },
  choicesOrder: {
    type: Array,
    default: () => [],
  },
  userData: {
    type: Object,
    default: () => ({}),
  },
  flash: {
    type: Object,
    default: () => ({}),
  },
  allAnswerQuestionAnswers: {
    type: Object,
    default: () => ({}),
  },
})

const onFinishedExamination = () => {
  Inertia.get(route('result'))
}

const onOpenConfirmationModal = () => {
  Swal.fire({
    icon: 'question',
    title: '解説を終了します。',
    text: 'よろしいですか？',
    showCancelButton: true,
    confirmButtonText: 'はい',
    cancelButtonText: 'いいえ',
  }).then((result) => {
    if (result.isConfirmed) {
      onFinishedExamination()
    }
  })
}

const isButtonClick = ref(false)
const isClickedQuestionList = ref(false)

const onClickedType = (id) => {
  Inertia.get(route('commentary', {
    examination: props.examination.id,
    type: id,
  }))
}

const onClickedQuestionList = () => {
  isClickedQuestionList.value = true
  isButtonClick.value = false
}

const onClickedButton = () => {
  isClickedQuestionList.value = false
  isButtonClick.value = true
}

const questionListMenu = ref(false)
const onClickedQuestionListMenu = () => {
  questionListMenu.value = !questionListMenu.value
}
const onResize = ref(false)
const switchByWidth = () => {
  if (window.matchMedia('(max-width: 770px)').matches) {
    onResize.value = true
    questionListMenu.value = false
  } else {
    onResize.value = false
    questionListMenu.value = true
  }
}
onMounted(() => {
  switchByWidth()
  window.addEventListener('resize', switchByWidth)
})

const onClickedAnswerListButton = () => {
  Inertia.get(route('commentary.answer-list', {
    examination: props.examination.id,
  }))
}
</script>
